import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.235 7.235a.375.375 0 0 1 .53 0l3.86 3.86 3.86-3.86a.375.375 0 1 1 .53.53l-3.86 3.86 3.86 3.86a.375.375 0 0 1-.53.53l-3.86-3.86-3.86 3.86a.375.375 0 1 1-.53-.53l3.86-3.86-3.86-3.86a.375.375 0 0 1 0-.53",
		clipRule: "evenodd"
	})
});
export default SvgCross;
